"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24LogoApple = function Svg24LogoApple(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M17.02 11.094c.027 2.875 2.523 3.832 2.55 3.844-.02.068-.398 1.364-1.314 2.703-.792 1.157-1.614 2.31-2.909 2.334-1.272.024-1.681-.754-3.136-.754-1.454 0-1.908.73-3.112.778-1.25.047-2.202-1.252-3-2.405-1.632-2.359-2.879-6.666-1.204-9.573.831-1.444 2.318-2.358 3.931-2.381 1.227-.024 2.386.825 3.136.825s2.157-1.02 3.637-.87c.62.025 2.358.25 3.475 1.884-.09.056-2.075 1.211-2.053 3.615zm-2.39-7.06c.663-.804 1.11-1.922.988-3.034-.956.038-2.113.637-2.799 1.44-.615.71-1.153 1.849-1.008 2.939 1.066.082 2.155-.542 2.819-1.345",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24LogoApple.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24LogoApple;
exports.default = _default;